/**
 * The misspelled word the Spell Check popover is open on, if any.
 *
 * The popover opens at the word on the canvas, so the frame that holds the word has to say where it
 * is. The panel knows which word and the frame knows where it sits, and they do not share a parent,
 * so this module-level store, like the underline and peek stores next to it, carries the one word
 * between them. At most one word is active at a time.
 *
 * It is independent of Show underlines: the popover opens at the word whether or not the squiggles
 * are drawn.
 */
import type { SpellActiveWord } from './types/spell-active-word'

let activeWord: SpellActiveWord | null = null
const listeners = new Set<() => void>()

function notify(): void {
  listeners.forEach((listener) => listener())
}

/** Sets the active word, or none with `null`. Subscribers are told only on a change. */
export function setSpellActiveWord(next: SpellActiveWord | null): void {
  if (
    activeWord === next ||
    (activeWord &&
      next &&
      activeWord.shapeId === next.shapeId &&
      activeWord.start === next.start &&
      activeWord.end === next.end)
  ) {
    return
  }

  activeWord = next
  notify()
}

export function getSpellActiveWord(): SpellActiveWord | null {
  return activeWord
}

export function subscribeToSpellActiveWord(listener: () => void): () => void {
  listeners.add(listener)

  return () => {
    listeners.delete(listener)
  }
}
